<template>
  <div class="modal">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="top">
        <div class="title"><strong>Amigos(as)</strong></div>
        <div class="subTitle">Quantidade: {{ props.item.length }}</div>
        <div class="close" @click="emits('close')">X</div>
      </div>
      <div class="content">
        <div class="boxItem" v-for="(i, index) in item" :key="index">
          <div class="avatar"
               :style="{backgroundImage: `url('${avatarUrl(i.username, { action: '', head_direction: 3, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
          <div class="text">{{ i.username }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { avatarUrl } from '@/services/api.js'

const emits = defineEmits(['close'])
const props = defineProps({
  item: Object
})
</script>

<style scoped>
.modal .box {
  width: 600px;
}


.modal .top {
  height: 70px;
}

.modal .subTitle {
  margin-left: 10px;
}

.modal .content {
  width: calc(100% - 10px);
  height: 400px;
  overflow: auto;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  box-shadow: none;
  border-radius: 12px;
  margin: 0 0 0 5px;
  padding: 4px;
}

.modal .content::-webkit-scrollbar {
  width: 5px;
}

/*noinspection ALL*/
.modal .content::-webkit-scrollbar-thumb {
  background-color: var(--color2);
  border-radius: 10px;
}

.modal .content .boxItem {
  position: relative;
  width: calc(100% / 3 - 10px);
  height: 172px;
  background-color: #f1f1f1;
  margin-top: 5px;
  border-radius: 4px;
  padding: 5px 0;
}

.modal .content .boxItem .avatar {
  width: 100%;
  height: 120px;
  background-position: center;
  background-repeat: no-repeat;
  margin: 5px 0;
}

.modal .content .boxItem .text {
  width: calc(100% - 20px);
  height: 30px;
  background-color: rgba(0, 0, 0, .4);
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  margin-left: 10px;
}

</style>
